import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Case = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M2.334 1.33h11.333v15.333H2.334V1.33ZM13 1.997H3v14h10v-14Z" />
      <path d="M9.667 5.33H6.333a.333.333 0 1 1 0-.666h3.334a.333.333 0 0 1 0 .667ZM9.667 7.997H6.333a.333.333 0 1 1 0-.667h3.334a.333.333 0 0 1 0 .667ZM8 9.662a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 3.333a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666Z" />
    </svg>
  );
};

Case.category = 'product-category';

Case.displayName = 'Case';
